// import React from 'react';
// import { Select, Checkbox, List, Col, Row, Table, Button, Space, Input, Modal, message, Spin, Badge } from 'antd';
// import { connect } from 'react-redux';
// import { requestServerPost, selectPage, requestNodeServerPost, requestServerGet } from '../../actions';
// import PlaylistTableView from '../views/PlaylistTableView';
// import Column from 'antd/lib/table/Column';
// import ActionButton from '../ActionButton';
// import "./PlaylistSelectorPopup.css";
// import PopupManager from '../../managers/PopupManager';
// import DataHelper from '../../helpers/DataHelper';
// import { ExclamationCircleFilled, ExclamationCircleOutlined } from '@ant-design/icons';
// import PermissionManager from '../../managers/PermissionManager';
// import { THEME_PALLETE } from '../../Theme';

// const { Option } = Select;
// const columns = [
//     {
//         title: 'Screen Name',
//         dataIndex: 'ScreenName',
//         render: (value, record, index) => {
//             return <Space>
//                 <Badge
//                 count={
//                     record.PendingPublished == 1 ?
//                         <ExclamationCircleFilled
//                             style={{
//                                 fontWeight: 800,
//                                 color: THEME_PALLETE.orange,
//                             }}
//                         /> : 0
//                 }
//                 showZero={false}
//             >
//                 <img style={{ width: "auto", height: "20px", objectFit:"cover", marginBottom:"3px"}} src="/cms/assets/svgs/icons/screen_icon.svg"></img>
//             </Badge>
//                 {value}</Space>
//         }
//     },
//     {
//         title: 'Current Campaign',
//         dataIndex: 'CampaignName',
//     }
// ];
// class ScreenSelectorPopup extends React.Component {

//     constructor(props) {
//         super(props);
//         this.state = {
//             screenDatas: [],
//             selectedRowKeys: [], // Check here to configure the default column
//             loading: false,
//             screenNameFilter: ""
//         }
//     }

//     componentDidMount() {
//         this.reloadScreens();
//     }

//     checkContainsForiegnScreens = () => {

//         const { campaignData = null } = this.props;

//         return this.state.selectedRowKeys.some(screenID => {
//             const sData = this.state.screenDatas.find(sDat => { return sDat.ScreenID === screenID })
//             return (sData.CampaignID !== campaignData.CampaignID)
//         });
//     }

//     validateSelectingAll = () => {
//         const screensWithCampaign = this.getScreensWithThisCampaign();
//         const containForiengScreens = this.checkContainsForiegnScreens();

//         return (this.state.selectedRowKeys.length === screensWithCampaign.length) && !containForiengScreens;
//     }

//     reloadScreens = (doUpdateSelections = true) => {
//         const { selectedBranchData, campaignData = null } = this.props;

//         this.setState({ loading: true });

//         DataHelper.getScreens({ brandid: campaignData.BrandID }, this.props)
//             .then((data) => {
//                 this.setState(
//                     { screenDatas: data, loading: false },
//                     doUpdateSelections ? ()=>{this.selectScreensWithThisCampaign(true)} : () => { }
//                 );
//             })
//             .catch(() => {
//                 this.setState({ loading: false });
//             });
//     };

//     // reloadScreens = (doUpdateSelections = true) => {

//     //     const {  selectedBranchData,  campaignData = null  } = this.props;

//     //     // console.log("campaignDatacampaignDatacampaignData " + JSON.stringify(campaignData))
//     //     DataHelper.getScreens({ brandid: campaignData.BrandID}, this.props).then((data) => {
//     //         this.setState({ screenDatas: data }, doUpdateSelections ? this.selectScreensWithThisCampaign : () => { })
//     //     })
//     // }

//     getScreensWithThisCampaign = (needsPublishOnly = false) => {
//         const { campaignData = null } = this.props;
//         return this.state.screenDatas.filter(s => { return ((s.CampaignID === campaignData.CampaignID) && (needsPublishOnly ? s.PendingPublished == 1 : true)) }).map((sData, index) => sData.ScreenID)
//     }

//     selectScreensWithThisCampaign = (needsPublishOnly = false) => {

//         const { campaignData = null } = this.props;
//         const screenWithCampaign = this.getScreensWithThisCampaign(needsPublishOnly);
//         this.setState({ selectedRowKeys: screenWithCampaign })
//     }
//     filter = (inputValue, path) => {
//         return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
//     }

//     onChange = (value, selectedOptions) => {
//         const { onChange } = this.props;
//         onChange(value, selectedOptions);
//     }

//     renderList = () => {

//         const { onItemSelected = () => { } } = this.props
//         const mappedData = this.state.screenDatas.map(d => {
//             return { ...d, key: d.ScreenID }
//         })
//         return (

//             <List
//                 size="medium"
//                 header={<div>Select Screens To Assign to</div>}
//                 footer={<div></div>}
//                 bordered
//                 dataSource={mappedData}
//                 renderItem={item =>
//                     <div onClick={() => {
//                         onItemSelected(item)
//                         PopupManager.closePopup();
//                     }} className="center-content playlist-choice" style={{ padding: "2px", border: "1px solid #f0f0f0", borderRadius: "4px" }}>
//                         <Row align="middle" justify="space-between" gutter={[4, 0]} style={{ width: "95%", height: "30px", cursor: "pointer" }}>
//                             <Col span={20}><img style={{ width: "20px", height: "20px", marginRight: "16px" }} src="/cms/assets/svgs/icons/screen_icon.svg"></img>{item.ScreenName}</Col>

//                         </ Row>
//                     </div>}
//             />
//         )
//     }

//     assignToScreens = () => {

//         const { requestServerPost, usertoken, campaignData = null } = this.props;

//         if (!campaignData)
//             return;
//         const params = new FormData();
//         const screenids = this.state.selectedRowKeys.join(",")

//         var arr = [{ screenids: screenids, campaignid: campaignData.CampaignID }];

//         params.append("screens", JSON.stringify(arr))

//         requestServerPost("update_screencampaign", params, { }, (response) => {
//             console.log("update_screencampaign completed");
//             this.reloadScreens(false);
//         }, usertoken);
//     }

//     save = () => {

//         const { brandid, campaignData = null } = this.props;
//         const hasOverrides = this.state.selectedRowKeys.some(screenID => {
//             const sData = this.state.screenDatas.find(sDat => { return sDat.ScreenID === screenID })
//             return (sData.CampaignID !== campaignData.CampaignID) && sData.CampaignID !== ""
//         })

//         if (hasOverrides) {
//             Modal.confirm({
//                 title: 'Confirm',
//                 icon: <ExclamationCircleOutlined />,
//                 content: `One or more selected screens are currently assigned with other campaigns, would you like to replace them with "${campaignData.CampaignName}"?`,
//                 okText: 'OK',
//                 cancelText: 'Cancel',
//                 onOk: this.assignToScreens
//             });
//         }
//         else {
//             this.assignToScreens();
//         }
//     }

//     publish = () => {
//         const selectedScreens = this.state.selectedRowKeys.map(screenID => {
//             return this.state.screenDatas.find(sDat => { return sDat.ScreenID === screenID })
//         })

//         Modal.confirm({
//             title: 'Confirm',
//             icon: <ExclamationCircleOutlined />,
//             content: `Are you sure to publish content to the selected ${selectedScreens.length} screen(s)?`,
//             okText: 'OK',
//             cancelText: 'Cancel',
//             onOk: () => {
//                 DataHelper.publishContent(selectedScreens, () => {
//                     message.success(`Successfully published content to ${selectedScreens.length} screen(s)`);
//                     // this.reloadPage();
//                     this.reloadScreens();
//                 }, this.props)
//             }
//         });

//     }

//     onSelectChange = selectedRowKeys => {
//         this.setState({ selectedRowKeys });
//     };

//     onSelectCampaignScreensChanged = (e) => {
//         const checked = e.target.checked;

//         if (checked) {
//             this.selectScreensWithThisCampaign();
//         }
//     }

//     updateFilter = (e) => {
//         const filter = e.target.value;
//         this.setState({ screenNameFilter: filter });
//     }

//     render() {
//         const { campaignData } = this.props;
//         const { loading, selectedRowKeys } = this.state;
//         const rowSelection = {
//             selectedRowKeys,
//             onChange: this.onSelectChange,
//             selections: [
//                 Table.SELECTION_ALL,
//                 Table.SELECTION_INVERT,
//                 {
//                     key: 'all_campaign',
//                     text: `Select Screens with "${campaignData.CampaignName}"`,
//                     onSelect: changableRowKeys => {
//                         const screensWithThisCampaign = this.getScreensWithThisCampaign();
//                         this.setState({ selectedRowKeys: screensWithThisCampaign });
//                     },
//                 }
//             ],
//             preserveSelectedRowKeys: true
//         };
//         const hasSelected = selectedRowKeys.length > 0;
//         const isSelectingAll = this.validateSelectingAll();
//         const needSave = this.state.selectedRowKeys.some(screenID => {
//             const sData = this.state.screenDatas.find(sDat => { return sDat.ScreenID === screenID })
//             return (sData.CampaignID !== campaignData.CampaignID)
//         });

//         const allowPublishPermission = PermissionManager.checkPermission(PermissionManager.PERMISSION_KEY_SCREEN, PermissionManager.PERMISSION_TYPE_PUBLISH);
//         const canPublish = !needSave && hasSelected;

//         const mappedData = this.state.screenDatas.map((d, index) => {
//             return { ...d, key: d.ScreenID }
//         }).filter(sData => {
//             return sData.ScreenName.toLocaleLowerCase().includes(this.state.screenNameFilter.toLocaleLowerCase());
//         })
//         // .sort((a, b) => {
//         //     const aValue = (this.state.selectedRowKeys.indexOf(a.ScreenID) > -1) ? -1 : 0
//         //     const bValue = (this.state.selectedRowKeys.indexOf(b.ScreenID) > -1) ? -1 : 0

//         //     return aValue - bValue
//         // })

//         return (
//             // <Cascader
//             //     options={this.state.playlistOptions}
//             //     onChange={this.onChange}
//             //     placeholder="Select Playlist"
//             //     showSearch={this.filter}
//             // />
//             <div style={{ margin: 24 }}>
//                 <Spin spinning={loading} tip="Loading screens...">
//                     <div style={{ marginBottom: 16 }}>
//                         <Space>
//                             <Space>
//                                 <Button type="primary" onClick={this.save} disabled={!needSave} loading={loading}>
//                                     Assign To
//                                 </Button>
//                                 {allowPublishPermission ? (
//                                     <Button type="primary" onClick={this.publish} disabled={!canPublish} loading={loading}>
//                                         Publish
//                                     </Button>
//                                 ) : null}

//                             </Space>
//                         </Space>
//                         <span style={{ marginLeft: 8 }}>
//                             {hasSelected ? `Selected ${selectedRowKeys.length} screens` : ''}
//                         </span>
//                     </div>
//                     <Input onChange={this.updateFilter} value={this.state.screenNameFilter} placeholder="Filter with screen names" style={{ marginBottom: "8px" }}></Input>
//                     <Table rowSelection={rowSelection} columns={columns} dataSource={mappedData} />
//                     <Checkbox onChange={this.onSelectCampaignScreensChanged} checked={isSelectingAll}>{`Every Screen with "${campaignData.CampaignName}"`}</Checkbox>
//                 </Spin>
//             </div>
//             // <>{this.renderList()}</>

//         )
//     }
// }

// const mapStateToProps = (state) => {
//     return { userdata: state.userdata, usertoken: state.usertoken, selectedBrandData: state.selectedBrandData, selectedBranchData: state.selectedBranchData, selectedBranchData: state.selectedBranchData };
// }

// export default connect(mapStateToProps, { requestServerGet, requestServerPost, selectPage, requestNodeServerPost })(ScreenSelectorPopup);

import React from "react";
import {
  Checkbox,
  Col,
  Row,
  Table,
  Button,
  Space,
  Input,
  Modal,
  message,
  Spin,
  Badge,
} from "antd";
import { connect } from "react-redux";
import {
  requestServerPost,
  selectPage,
  requestNodeServerPost,
  requestServerGet,
} from "../../actions";
import "./PlaylistSelectorPopup.css";
import PopupManager from "../../managers/PopupManager";
import DataHelper from "../../helpers/DataHelper";
import {
  ExclamationCircleFilled,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import PermissionManager from "../../managers/PermissionManager";
import { THEME_PALLETE } from "../../Theme";
import { USE_SCREENS_FROM_WARROOM } from "../../Config";
import {
  Monitor,
  Upload,
  Send,
  Search,
  CheckSquare,
  AlertTriangle,
} from "lucide-react";
import {
  useProLanguage,
  PRO_TRANSLATIONS,
} from "../../global/ProLanguageContext";

class ScreenSelectorPopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      screenDatas: [],
      selectedRowKeys: [],
      loading: false,
      screenNameFilter: "",
    };
  }

  componentDidMount() {
    this.reloadScreens(true);
  }

  reloadScreens = (doUpdateSelections = true) => {
    const { campaignData } = this.props;

    this.setState({ loading: true });

    DataHelper.getScreens({ brandid: campaignData.BrandID }, this.props)
      .then((data) => {
        this.setState(
          { screenDatas: data, loading: false },
          doUpdateSelections
            ? () => {
                this.selectScreensWithThisCampaign(false);
              }
            : undefined,
        );
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  getScreensWithThisCampaign = (needsPublishOnly = false) => {
    const { campaignData } = this.props;
    if (!campaignData) return [];

    const filteredScreens = this.state.screenDatas
      .filter(
        (s) =>
          s.CampaignID === campaignData.CampaignID &&
          (needsPublishOnly ? s.PendingPublished == 1 : true),
      )
      .map((s) => s.ScreenID);

    console.log(
      "filteredScreens filteredScreens filteredScreens ",
      filteredScreens,
    );
    return filteredScreens;
  };

  selectScreensWithThisCampaign = (needsPublishOnly = false) => {
    console.log(
      "selectScreensWithThisCampaign needsPublishOnly ",
      needsPublishOnly,
    );
    const selectedRowKeys = this.getScreensWithThisCampaign(needsPublishOnly);
    console.log("selectedRowKeys ", selectedRowKeys);
    this.setState({ selectedRowKeys });
  };

  checkContainsForiegnScreens = () => {
    const { campaignData } = this.props;

    return this.state.selectedRowKeys.some((screenID) => {
      const sData = this.state.screenDatas.find((s) => s.ScreenID === screenID);
      return sData && sData.CampaignID !== campaignData.CampaignID;
    });
  };

  validateSelectingAll = () => {
    const screensWithCampaign = this.getScreensWithThisCampaign(false);
    const containForiengScreens = this.checkContainsForiegnScreens();
    return (
      this.state.selectedRowKeys.length === screensWithCampaign.length &&
      !containForiengScreens
    );
  };

  onSelectChange = (selectedRowKeys) => {
    this.setState({ selectedRowKeys });
  };

  onSelectCampaignScreensChanged = (e) => {
    if (e.target.checked) {
      this.selectScreensWithThisCampaign(false);
    }
  };

  updateFilter = (e) => {
    this.setState({ screenNameFilter: e.target.value });
  };

  assignToScreens = () => {
    const { requestServerPost, usertoken, campaignData } = this.props;
    if (!campaignData) return;

    const params = new FormData();
    params.append(
      "screens",
      JSON.stringify([
        {
          screenids: this.state.selectedRowKeys.join(","),
          campaignid: campaignData.CampaignID,
        },
      ]),
    );

    requestServerPost(
      "update_screencampaign",
      params,
      {},
      () => this.reloadScreens(false),
      usertoken,
    );
  };

  publish = () => {
    const { campaignData } = this.props;
    const t = this.props.langT || PRO_TRANSLATIONS.en.screenSelectorPopup;
    const selectedScreens = this.state.selectedRowKeys.map((id) =>
      this.state.screenDatas.find((s) => s.ScreenID === id),
    );

    Modal.confirm({
      title: t.confirmTitle,
      icon: <ExclamationCircleOutlined />,
      content: `${t.confirmPublish} ${selectedScreens.length} ${t.confirmPublishUnit}`,
      onOk: () => {
        DataHelper.publishContent(
          selectedScreens,
          () => {
            message.success(
              `${t.publishSuccess} ${selectedScreens.length} ${t.publishSuccessUnit}`,
            );
            this.reloadScreens();
          },
          this.props,
        );
      },
    });
  };

  render() {
    const { campaignData } = this.props;
    const t = this.props.langT || PRO_TRANSLATIONS.en.screenSelectorPopup;
    const { loading, selectedRowKeys, screenDatas, screenNameFilter } =
      this.state;

    const hasSelected = selectedRowKeys.length > 0;
    const isSelectingAll = this.validateSelectingAll();

    const needSave = selectedRowKeys.some((screenID) => {
      const sData = screenDatas.find((s) => s.ScreenID === screenID);
      return sData && sData.CampaignID !== campaignData.CampaignID;
    });

    const allowPublishPermission = PermissionManager.checkPermission(
      PermissionManager.PERMISSION_KEY_SCREEN,
      PermissionManager.PERMISSION_TYPE_PUBLISH,
    );

    const canPublish = !needSave && hasSelected;

    const mappedData = screenDatas
      .map((d) => ({ ...d, key: d.ScreenID }))
      .filter((s) =>
        s.ScreenName.toLowerCase().includes(screenNameFilter.toLowerCase()),
      );

    const columns = [
      {
        title: (
          <span
            style={{
              fontSize: 12,
              fontWeight: 600,
              color: "#64748b",
              textTransform: "uppercase",
              letterSpacing: "0.05em",
            }}
          >
            {t.colScreenName}
          </span>
        ),
        dataIndex: "ScreenName",
        render: (value, record) => (
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{ position: "relative", flexShrink: 0 }}>
              <div
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: 8,
                  background:
                    record.PendingPublished == 1 ? "#fef3c7" : "#f1f5f9",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Monitor
                  size={15}
                  color={record.PendingPublished == 1 ? "#d97706" : "#6366f1"}
                />
              </div>
              {record.PendingPublished == 1 && (
                <div
                  style={{
                    position: "absolute",
                    top: -3,
                    right: -3,
                    width: 10,
                    height: 10,
                    borderRadius: "50%",
                    background: "#f97316",
                    border: "2px solid #fff",
                  }}
                />
              )}
            </div>
            <span style={{ fontSize: 13, fontWeight: 500, color: "#0f172a" }}>
              {value}
            </span>
          </div>
        ),
      },
      {
        title: (
          <span
            style={{
              fontSize: 12,
              fontWeight: 600,
              color: "#64748b",
              textTransform: "uppercase",
              letterSpacing: "0.05em",
            }}
          >
            {t.colCurrentCampaign}
          </span>
        ),
        dataIndex: "CampaignName",
        render: (value) => (
          <span
            style={{
              fontSize: 13,
              color: value ? "#334155" : "#94a3b8",
              fontStyle: value ? "normal" : "italic",
            }}
          >
            {value || t.noCampaign}
          </span>
        ),
      },
    ];

    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
      preserveSelectedRowKeys: true,
      selections: [
        Table.SELECTION_ALL,
        Table.SELECTION_INVERT,
        {
          key: "all_campaign",
          text: `Select Screens with "${campaignData.CampaignName}"`,
          onSelect: () => {
            this.setState({
              selectedRowKeys: this.getScreensWithThisCampaign(false),
            });
          },
        },
      ],
    };

    const pendingCount = screenDatas.filter(
      (s) => s.PendingPublished == 1,
    ).length;

    return (
      <div>
        {/* Header — always visible, outside Spin */}
        <div
          style={{
            background: "linear-gradient(135deg, #6366f1, #4f46e5)",
            padding: "24px 28px 20px",
            margin: "-24px -24px 0",
            borderRadius: "8px 8px 0 0",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
            <div
              style={{
                width: 44,
                height: 44,
                borderRadius: 12,
                background: "rgba(255,255,255,0.18)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Send size={22} color="#fff" />
            </div>
            <div>
              <div style={{ fontSize: 18, fontWeight: 700, color: "#fff" }}>
                {t.title}
              </div>
              <div
                style={{
                  fontSize: 12,
                  color: "rgba(255,255,255,0.75)",
                  marginTop: 2,
                }}
              >
                {campaignData.CampaignName}
                {pendingCount > 0 && (
                  <span
                    style={{
                      marginLeft: 8,
                      background: "rgba(249,115,22,0.9)",
                      color: "#fff",
                      borderRadius: 6,
                      padding: "1px 8px",
                      fontSize: 11,
                      fontWeight: 600,
                    }}
                  >
                    {pendingCount} {t.pending}
                  </span>
                )}
              </div>
            </div>
          </div>

          {/* Action tabs */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              marginTop: 20,
            }}
          >
            <button
              onClick={this.assignToScreens}
              disabled={!needSave}
              style={{
                height: 36,
                padding: "0 18px",
                borderRadius: 8,
                fontSize: 13,
                fontWeight: 600,
                cursor: needSave ? "pointer" : "not-allowed",
                background: needSave
                  ? "rgba(255,255,255,0.95)"
                  : "rgba(255,255,255,0.25)",
                color: needSave ? "#4f46e5" : "rgba(255,255,255,0.6)",
                border: "none",
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
                transition: "all 0.15s",
              }}
            >
              <Upload size={14} /> {t.assignTo}
            </button>
            {allowPublishPermission && (
              <button
                onClick={this.publish}
                disabled={!canPublish}
                style={{
                  height: 36,
                  padding: "0 18px",
                  borderRadius: 8,
                  fontSize: 13,
                  fontWeight: 600,
                  cursor: canPublish ? "pointer" : "not-allowed",
                  background: canPublish ? "#fff" : "rgba(255,255,255,0.25)",
                  color: canPublish ? "#059669" : "rgba(255,255,255,0.6)",
                  border: "none",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 6,
                  transition: "all 0.15s",
                }}
              >
                <Send size={14} /> {t.publish}
              </button>
            )}
            {hasSelected && (
              <span
                style={{
                  marginLeft: 6,
                  background: "rgba(255,255,255,0.2)",
                  color: "#fff",
                  borderRadius: 20,
                  padding: "3px 12px",
                  fontSize: 12,
                  fontWeight: 600,
                }}
              >
                {selectedRowKeys.length} {t.selected}
              </span>
            )}
          </div>
        </div>

        {/* Body — Spin only covers this section */}
        <Spin spinning={loading} tip="Loading screens...">
          <div style={{ padding: "20px 4px 0" }}>
            {/* Search */}
            <div style={{ position: "relative", marginBottom: 16 }}>
              <Search
                size={14}
                color="#94a3b8"
                style={{
                  position: "absolute",
                  left: 12,
                  top: "50%",
                  transform: "translateY(-50%)",
                  zIndex: 1,
                  pointerEvents: "none",
                }}
              />
              <input
                value={screenNameFilter}
                onChange={this.updateFilter}
                placeholder={t.filterPlaceholder}
                style={{
                  width: "100%",
                  height: 38,
                  borderRadius: 8,
                  border: "1px solid #e2e8f0",
                  paddingLeft: 36,
                  paddingRight: 12,
                  fontSize: 13,
                  color: "#0f172a",
                  outline: "none",
                  background: "#f8fafc",
                }}
              />
            </div>

            {/* Table */}
            <Table
              rowSelection={rowSelection}
              columns={columns}
              dataSource={mappedData}
              size="middle"
              rowClassName={(record) =>
                selectedRowKeys.includes(record.ScreenID)
                  ? "selected-screen-row"
                  : ""
              }
              pagination={{
                pageSize: 10,
                size: "small",
                style: { marginTop: 12 },
              }}
              style={{
                borderRadius: 10,
                overflow: "hidden",
                border: "1px solid #f1f5f9",
              }}
            />

            {/* Footer checkbox */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                marginTop: 14,
                padding: "12px 14px",
                background: "#f8fafc",
                borderRadius: 10,
                border: "1px solid #f1f5f9",
              }}
            >
              <Checkbox
                onChange={this.onSelectCampaignScreensChanged}
                checked={isSelectingAll}
              >
                <span
                  style={{ fontSize: 13, fontWeight: 500, color: "#334155" }}
                >
                  {t.everyScreenWith}{" "}
                  <strong>&ldquo;{campaignData.CampaignName}&rdquo;</strong>
                </span>
              </Checkbox>
            </div>
          </div>
        </Spin>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userdata: state.userdata,
  usertoken: state.usertoken,
  selectedBrandData: state.selectedBrandData,
  selectedBranchData: state.selectedBranchData,
});

const ConnectedScreenSelectorPopup = connect(mapStateToProps, {
  requestServerGet,
  requestServerPost,
  selectPage,
  requestNodeServerPost,
})(ScreenSelectorPopup);

const ScreenSelectorPopupWithLang = (props) => {
  const { lang } = useProLanguage();
  const t =
    PRO_TRANSLATIONS[lang]?.screenSelectorPopup ||
    PRO_TRANSLATIONS.en.screenSelectorPopup;
  return <ConnectedScreenSelectorPopup langT={t} {...props} />;
};

export default ScreenSelectorPopupWithLang;
